<template>
    <div class="select-modal">
        <loader v-if="isLoading" />
        <div class="modal" v-if="modalOpen">
            <modal-container
                :val="ctrtemp[index].id"
                :containerName="ctrModalName[modalIndex]"
                :list="tmpLPS"
            />
        </div>

        <div class="tab-geral form-columns-fit">
            <div class="columns is-flex-wrap">
                <div class="column is-8">
                    <search-bar :onSearch="debouncedOnSearchAll" tooltipLabel="msg-campo-busca-promotor-produto" />
                </div>

                <!-- Botão adicionar campos -->
                <div class="column is-3">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="openModal(2, selectedProdutoTomadaDePreco)"
                    >
                        {{ $t('adicionar-produto') }}
                    </button>
                </div>
            </div>
        </div>

        <div class="registry-wrapper">
            <empty-table-message v-if="isEmpty" />
            <b-table v-else :data="selectedProdutoTomadaDePreco" class="data-table">
                <b-table-column
                    v-for="(f, i) in fields"
                    :key="i"
                    :field="f.key"
                    :width="f.width"
                    :label="f.key != 'excluir' ? $t(f.key) : ''"
                    :class="''"
                    v-slot="props"
                >
                    <div v-if="f.key == 'produto'">
                        {{ props.row['label'] }}
                    </div>
                    <div v-else-if="f.key == 'excluir'" class="no-strike">
                        <b-button
                            v-if="permissao.delete"
                            class="action-button"
                            :type="'is-danger'"
                            :icon-right="'delete'"
                            @click="confirmExclusion(i, props.row)"
                            v-tippy 
                            :title="$t('excluir')"
                        />
                    </div>
                    <div v-else>
                        {{ props.row[f.key] }}
                    </div>
                </b-table-column>
            </b-table>
        </div>
    </div>
</template>

<script>
import ProdutoService from '@/services/vendas/produto/ProdutoService';
import ProContratoService from '@/services/promotor/pro_cliente/ProContratoService';

export default {
    props: {
        value: {
            type: Object,
            default() {
                return {};
            },
        },
        index: {
            default: 0,
        },
        ctrtemp: {
            type: Array,
            default: () => [],
        },
        permissao: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            tmpLPS: [],
            modalOpen: false,
            modalIndex: 0,
            ctrModalName: [
                'Produto',
                'ConfirmationWindow', // não mais utilizado; mantido para não bagunçar o index
                'SelectProdutoContrato',
            ],
            contratoservice: new ProContratoService(this.$http, this.$router),
            prodservice: new ProdutoService(this.$http, this.$router),
            filter: {
                cidades: [],
                estados: [],
                redes: [],
                bandeiras: [],
            },
            selectedProdutoTomadaDePreco: [],
            allselected: false,
            searchQueryAll: [],
            filterable: false,
            deleteThis: {},
            isEmpty: false,
            fields: [
                { key: 'produto', width: 600 },
                { key: 'excluir', width: 20 },
            ],
            isLoading: false,
            searchNumberAdd: 0,
        };
    },
    created() {
        this.debouncedOnSearchAll = this.debounce(this.onSearchAll, 500);

        if (this.value && this.idcontrato) {
            if (this.value.procontratoproduto.length > 0) {
                this.carregaContratoProdutoTomPreco();
            } else {
                this.isEmpty = true;
            }
        } else {
            this.isEmpty = true;
        }
        this.$on('update-contrato-produto', this.updateTomadaPreco);
    },
    methods: {
        confirmExclusion(index, item) {
            if (this.selectedProdutoTomadaDePreco.length == 1) {
                index = 0;
            }
            this.deleteThis = index;
            /**
             * @70188 - Adicionado mensagem informando que o caso seja deletada a LPS
             * e ela esteja inserida á uma rota a mesma será removida.
             */
            this.$root.confirm({
                message: `
                    <strong>${this.$t('msg-confirmacao-exclusao-n', { n: item.label })}</strong>
                    <br>
                    ${this.$t('msg-alert-lps-rota')}`,
                onConfirm: this.excluirProdTomPrecoDoContrato,
            });
        },
        excluirProdTomPrecoDoContrato() {
            let index = this.deleteThis;
            this.selectedProdutoTomadaDePreco.splice(index, 1);
            this.deleteThis = {};
            if (this.selectedProdutoTomadaDePreco.length <= 0) {
                this.isEmpty = true;
            }
        },
        onSearchAll(value) {
            let valueTomPreco = value;
            if (valueTomPreco != '') {
                this.carregaProdutoTomPreco(valueTomPreco);
            } else {
                this.selectedProdutoTomadaDePreco = this.searchQueryAll;
            }
        },
        mapProdutoTomPreco(body) {
            let list = body.map((i) => {
                return {
                    id: i,
                    label: i.produto.descricao,
                    tipo: i.tipo,
                    selected: true,
                };
            });
            return list;
        },
        mapProdTomPrecoFromSelect(items) {
            return {
                id: items.id,
                label: items.label,
                selected: true,
            };
        },
        mapProdTomPrecoContrato(body) {
            let list = body.map((i) => {
                return {
                    id: i,
                    label: i.produto.descricao,
                    tipo: i.tipo,
                    selected: true,
                };
            });
            return list;
        },
        carregaProdutoTomPreco(valueTomPreco) {
            if (this.searchNumberAdd == 0) {
                this.contratoservice
                    .findProductByContratoId(this.idcontrato, valueTomPreco)
                    .then(this.mapProdTomPrecoContrato)
                    .then((prod) => {
                        this.selectedProdutoTomadaDePreco = prod;
                        this.filterable = true;
                    });
            } else {
                this.$root.showMessage('alert', 'msg-busca-ao-salvar');
            }
        },
        carregaContratoProdutoTomPreco(value = '') {
            this.isLoading = true;
            this.contratoservice
                .findProductByContratoId(this.idcontrato, value)
                .then(this.mapProdTomPrecoContrato)
                .then((prod) => {
                    prod.forEach((pd) => {
                        if (pd.tipo == 'T') {
                            this.selectedProdutoTomadaDePreco.push(pd);
                        }
                    });
                    this.$emit('selectedProdutoTomadaDePreco', this.selectedProdutoTomadaDePreco);
                    this.searchQueryAll = this.selectedProdutoTomadaDePreco;
                    if (this.selectedProdutoTomadaDePreco.length <= 0) this.isEmpty = true;
                    else {
                        this.isEmpty = false;
                    }
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os contratos!');
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        updateTomadaPreco(prod) {
            if (prod.length != this.selectedProdutoTomadaDePreco.length) {
                this.searchNumberAdd = this.selectedProdutoTomadaDePreco.length;
            }
            let tmp = prod.map(this.mapProdTomPrecoFromSelect);
            this.selectedProdutoTomadaDePreco = tmp;
            this.$emit('selectedProdutoTomadaDePreco', this.selectedProdutoTomadaDePreco);
            if (this.selectedProdutoTomadaDePreco.length > 0) {
                this.isEmpty = false;
            } else {
                this.isEmpty = true;
            }
        },
        openModal(idx, list) {
            this.tmpLPS = list;
            this.modalIndex = idx;
            this.modalOpen = true;
        },
    },
};
</script>

<style lang="scss" scoped>
.botao-acao {
    margin-top: 24px;
    width: 100%;
    height: 40px;
}

.registry-wrapper {
    margin-top: 50px;
    margin-bottom: 50px;
}
@media (max-width: 760px) {
    .botao-acao {
        margin-top: 15px;
    }
}
</style>
